module.exports = __webpack_public_path__ + "assets/img/LTC017.c80e4031.png";